import { useContext } from 'react'

import ctx from '@/context/AppContext'

const useUser = () => {
  const {
    customerId: cId,
    personId: pId,
    personEmail,
    token,
    workspaceSettings,
    squads,
    skillLevel,
    accessKey,
  } = useContext(ctx)
  const personId = pId ?? ''
  const userEmail = personEmail ?? ''
  const customerId = cId ?? ''
  const isDeveloperModeEnabled = workspaceSettings?.developerMode ?? false

  const roles =
    workspaceSettings?.allowedCustomers.find(customer => customer.id === customerId)
      ?.roles ?? []

  return {
    customerId,
    personId, // Deprecated - use user ID instead
    userEmail,
    token: token ?? '',
    isDeveloperModeEnabled,
    roles,
    squads,
    skillLevel,
    accessKey,
  }
}

export default useUser
